








































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { bus } from "@/pages/transitweb/main";

import { MapState } from "@/store/map/types";

import { GChart } from "vue-google-charts";

import InfoPanelDashboard from "./InfoPanelDashboard.vue";
import InfoPanelCharts from "./InfoPanelCharts.vue";
import CO2 from "./CO2.vue";

@Component({
    components: {
        GChart,
        CO2,
        InfoPanelDashboard,
        InfoPanelCharts,
    },
})
export default class InfoPanelAir extends Vue {
    @Prop() private info!: any;

    @Prop() private chart_data!: any;
    @Prop() private hidecounts!: boolean;
    @Prop() private statisticType!: string;

    @State("map") mapstate!: MapState;

    @Getter("auth/isAllowedSensitiveInfo") isAllowedSensitiveInfo!: boolean;

    @Action("map/setFlyTo") setFlyTo: any;

    get air(): any {
        return this.info || this.mapstate.featureOfInterest?.properties || {};
    }

    getOrigDest(name: boolean) {
        if (!this.air) {
            return "";
        }
        return this.air.air_name != null
            ? this.splitAirNameByDash(this.air.air_name, name)
            : "Undefined";
    }

    splitAirNameByDash(
        str: any,
        name: boolean,
    ): { beforeDash: string; afterDash: string } {
        const parts = str.split("-");
        const beforeDash = parts[0].trim();
        const afterDash = parts.slice(1).join("-").trim();

        return name ? afterDash : beforeDash;
    }

    onClose() {
        //this.expansionPanel = null;
        this.$emit("closed", this);
    }

    numberWithCommas(x: any): string {
        return Number(x).toLocaleString();
    }

    onCriticalLink() {
        var e: any = [this.air.link_id];
        //this.$emit('critical_link', 'critical_link', e, true)
        bus.$emit("add_special_filter", "critical_link", e, true);
    }

    onCloseLink() {
        var e = {
            task: {
                name:
                    "Close " +
                    this.air.air_name +
                    " for segment " +
                    this.air.link_id,
            },
        };
        bus.$emit("create_task", e);
    }

    onCloseAirLine() {
        var e = {
            task: {
                name: "Close " + this.air.air_name,
            },
        };
        bus.$emit("create_task", e);
    }

    onAddNameFilter() {
        var e: any = [this.air.air_name];
        bus.$emit("append_name_filter", "flightpath", e);
        this.onClose();
    }
}
